import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\"],\"variable\":\"--font-open-sans\"}],\"variableName\":\"openSans\"}");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Vidaloka\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"variable\":\"--font-vidaloka\"}],\"variableName\":\"vidaloka\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/anders/dev/presentgatan.se/src/app/components/Underline/underline.js");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/home/anders/dev/presentgatan.se/src/app/components/Header/header.module.scss");
